/**
 * @module 乐易花相关模块路由
 */
export default [
  {
    path: '/yjh/loanMarket',
    name: 'loan_market',
    component: () => import('@/pages/activity/yjh-app/loanMarket/loan-market'),
    meta: { title: '精选贷款' }
  },
  {
    path: '/yjh/smartMatch',
    name: 'smart_match',
    component: () => import('@/pages/activity/yjh-app/loanMarket/smart-match'),
    meta: { title: '智能匹配' }
  },
  {
    path: '/yjh/borrowWay',
    name: 'borrow_way',
    component: () => import('@/pages/activity/yjh-app/borrow-way'),
    meta: { title: '借款攻略' }
  },
  {
    path: '/yjh/cancelAccount',
    name: 'cancel_account',
    component: () => import('@/pages/activity/yjh-app/cancelAccount/index'),
    meta: { title: '注销账户' }
  },
  {
    path: '/yjh/cancelAccountConfirm',
    name: 'cancel_account_confirm',
    component: () => import('@/pages/activity/yjh-app/cancelAccount/confirm'),
    meta: { title: '注销账户' }
  },
  {
    path: '/yjh/productIntro',
    name: 'product_intro',
    component: () => import('@/pages/activity/yjh-app/product-intro'),
    meta: { title: '关于我们' }
  }
]
